export default __webpack_public_path__ + "static/media/selfmade_logo.922940b2.svg";